import { Injectable } from '@angular/core';
import { CustomerId } from "../../../../api-client/openapi/models/customer-id";
import { ApplicationsService } from "../../../../api-client/openapi/services";
import { BehaviorSubject, catchError, map, Observable, of, switchMap, tap } from "rxjs";
import { AvailableApplications } from "../../../../api-client/openapi/models/available-applications";
import {
  GetCustomerApplicationsResponse
} from "../../../../api-client/openapi/models/get-customer-applications-response";
import { AuthenticationService } from '../../services/authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class CloudApplicationsAdminService {

  private hasAppStream = new BehaviorSubject<boolean>(false);
  public hasAppStream$ = this.hasAppStream.asObservable()
  private hasLicenseServer = new BehaviorSubject<boolean>(false);
  public hasLicenseServer$ = this.hasLicenseServer.asObservable()

  constructor(
    private applicationsApiService: ApplicationsService,
    private authService: AuthenticationService
  ) { }

  public listApplicationsForCustomer(id: CustomerId): Observable<AvailableApplications> {
    return this.applicationsApiService.v1CustomersCustomerIdApplicationsGet({
      customerId: id
    }).pipe(
      map(v => v.availableApplications)
    )
  }

  public updateApplications(id: CustomerId, applications: AvailableApplications): Observable<GetCustomerApplicationsResponse> {
    return this.applicationsApiService.v1CustomersCustomerIdApplicationsPut({
      customerId: id,
      body: {
        availableApplications: {
          forming: applications.forming,
          tubeXpert: applications.tubeXpert,
          progDie: applications.progDie,
          assembly: applications.assembly
        }
      }
    })
  }

  public getCustomerPermissions() {
    this.authService.customerId$
    .pipe(
      switchMap((customerId) => {
        if(customerId) {
          return this.listApplicationsForCustomer(
            customerId || ''
          )
        } else {
          return of()
        }
      }),
      catchError((error) => {
        if (error.error.errorMessage === 'NotAuthorized') {
          this.hasLicenseServer.next(true);
        }
        throw error.error.errorMessage;
      }),
      tap(() => {
        this.hasAppStream.next(true);
      })
    ).subscribe()
  }
}
